
























import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {Component, Prop} from "vue-property-decorator";
import {CountryStore} from "../../store";
import {Country} from "@/interfaces/entity/country";
import {CommonStatus} from "@/enums/status";
import {RoleDeclare} from "@/enums/roledeclare";

@Component({
    name: "CountryAction"
})
export default class extends mixins(CommonMixin) {
    @Prop({ required: true }) id!: number;
    CommonStatus = CommonStatus;
    RoleDeclare = RoleDeclare;

    get record() {
        return CountryStore.data[this.id];
    }

    async save(id: number) {
        const country: Country = CountryStore.data[id];
        if (!country) return;
        try {
            CountryStore.updateDataCountryV2({ key: id, value: { ...country, isSaving: true } });
            await CountryStore.editCountryV2(country);
            CountryStore.updateCachedDataCountryV2({ key: id, value: country })
            this.$message.success("Sửa nước thành công");
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Sửa nước thất bại");
        } finally {
            CountryStore.updateDataCountryV2({ key: id, value: { ...country, isSaving: false } });
            CountryStore.updateDataCountryV2({ key: id, value: { ...country, editable: false } });
        }
    }

    edit(id: number) {
        if (!this.hasPermission(RoleDeclare.ROLE_CAN_EDIT_REGION)) {
            this.$notification.error({
                message: "Từ chối truy cập",
                description: "Bạn không có quyền truy cập"
            })
            return;
        }
        const country: any = { ...CountryStore.data[id] };
        if (!country) return;
        CountryStore.updateDataCountryV2({ key: id, value: { ...country, isSaving: false } });
        CountryStore.updateDataCountryV2({ key: id, value: { ...country, editable: true } });
    }

    async deleteCountry(id: number) {
        try {
            CountryStore.updateDataCountryV2({ key: id, value: { ...CountryStore.data[id], isDeleting: true } });
            await CountryStore.deleteCountryV2(id);
            this.$message.success("Xóa nước thành công");
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Xóa nước thất bại");
        } finally {
            CountryStore.updateDataCountryV2({ key: id, value: { ...CountryStore.data[id], isDeleting: false } });
        }
    }

    close(id: number) {
        let country = { ...CountryStore.data[id] };
        if (!country) return;
        country = { ...country, ...CountryStore.cachedData[id], ['editable']: false } as any;
        CountryStore.updateDataCountryV2({ key: id, value: country })
    }
}
